import { render, staticRenderFns } from "./CustomerNewBrief.vue?vue&type=template&id=a6ce3ba6&scoped=true&lang=pug&"
import script from "./CustomerNewBrief.vue?vue&type=script&lang=js&"
export * from "./CustomerNewBrief.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNewBrief.vue?vue&type=style&index=0&id=a6ce3ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ce3ba6",
  null
  
)

/* custom blocks */
import block0 from "./CustomerNewBrief.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports